module.exports = function() {
  return new Worker(__webpack_public_path__ + "16b3edd348a7d3d603cb.worker.js");
};